import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getFloor(pathname, queryParams = "", extraHeaders = {}) {
  return await instance({ baseURL: baseURL }).get(
    pathname + "?" + queryParams,
    {
      headers: extraHeaders,
    },
  ); // pathname is "/role"
}

export async function createFloor(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/floor" + pathname, body);
}

export async function updateFloor(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/floor" + pathname, body);
}

export async function deleteFloor(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/floor" + pathname, { data: body });
}
